import {
  type EnvironmentProviders,
  type FactoryProvider,
  inject,
  provideAppInitializer,
  type ValueProvider,
} from '@angular/core';
import { AppConfigService } from '@core/config/app-config.service';
import { APP_CONFIG, BUILD_TIME_ENVIRONMENT } from '@core/config/app-config.tokens';

import { environment } from '../../../environments/environment';

const buildTimeEnvironmentProvider: ValueProvider = {
  provide: BUILD_TIME_ENVIRONMENT,
  useValue: environment,
};

const appConfigTokenProvider: FactoryProvider = {
  provide: APP_CONFIG,
  deps: [AppConfigService],
  useFactory: (appConfigService: AppConfigService) => appConfigService.config,
};

const appConfigInitializerProviders: EnvironmentProviders = provideAppInitializer(() => {
  const appConfigService = inject(AppConfigService);
  return appConfigService.load();
});

export const appConfigProviders = [
  buildTimeEnvironmentProvider,
  appConfigInitializerProviders,
  appConfigTokenProvider,
];
